"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventCarousel = exports.EVENT_CAROUSEL_SELECT = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const EventCarouselView_1 = require("./EventCarouselView");
exports.EVENT_CAROUSEL_SELECT = {
    images: true,
    date: true,
    title: true,
    slug: true,
    category: {
        title: true,
    },
};
function EventCarousel({ className, }) {
    const { data, loading } = (0, app_1.useQuery)('getEvents', {
        select: exports.EVENT_CAROUSEL_SELECT,
        args: {
            all: true,
        },
    });
    if (loading) {
        return (0, jsx_runtime_1.jsx)(ui_1.Loading, {});
    }
    if (!data) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(EventCarouselView_1.EventCarouselView, { events: data.map((v) => (Object.assign(Object.assign({}, v), { image: v.images[0] }))), className: className }));
}
exports.EventCarousel = EventCarousel;
